export default __webpack_public_path__ + "static/media/add_shopping_cart_black_48dp.fdeffc80.svg";